import { Plug, Wifi, Trees, MapPin, ParkingSquare, ShowerHead } from "lucide-react";
import { rateIncludes, type RateIncludeIcon } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const iconMap: Record<RateIncludeIcon, typeof Plug> = {
  hookups: ShowerHead,
  power: Plug,
  wifi: Wifi,
  amenities: Trees,
  sites: ParkingSquare,
  location: MapPin,
};

export function RateIncludes() {
  return (
    <section
      id="includes"
      aria-labelledby="rate-includes-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow>More Than a Parking Space</Eyebrow>
            </Reveal>
            <h2 id="rate-includes-heading" className="display-lg mt-6">
              <MaskReveal>Your Stay Includes</MaskReveal>
              <MaskReveal delay={0.08}>the Essentials</MaskReveal>
            </h2>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base leading-relaxed text-muted-foreground">
              Full hookup RV sites in Auburn CA come with the connections and comforts that help
              make every stay feel settled from the moment you arrive.
            </p>
          </Reveal>
        </div>

        <ul className="mt-10 grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {rateIncludes.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <li key={item.id} className="bg-background">
                <Reveal delay={i * 0.05} className="group h-full">
                  <div className="flex h-full flex-col p-8 transition-colors duration-500 hover:bg-secondary/60 md:p-10">
                    <span className="flex size-14 items-center justify-center rounded-full border border-border bg-secondary/40 text-primary transition-all duration-500 group-hover:-translate-y-1 group-hover:border-primary/40 group-hover:bg-primary/10">
                      <Icon className="size-6" strokeWidth={1.4} />
                    </span>
                    <h3 className="mt-10 font-display text-2xl tracking-tight">{item.title}</h3>
                    <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">
                      {item.copy}
                    </p>
                  </div>
                </Reveal>
              </li>
            );
          })}
        </ul>

        <Reveal delay={0.1}>
          <ResortLink variant="solid" href="/amenities/" className="mt-10 w-full sm:w-auto">
            Explore Our Amenities
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
